import en from './en';

export default { en };



// WEBPACK FOOTER //
// ./src/components/Timestamp/copy/index.js